export const closeMenu = (
  setState: (value: React.SetStateAction<boolean>) => void,
  value: boolean,
  handleClose: Function
) => {
  setState(value);
  handleClose();
};
